declare global {
  interface Window {
    gtag: (command: string, ...args: unknown[]) => void;
  }
}

// Get measurement ID from environment variable or use a default for development
export const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-DS3J7HRDLB';

/**
 * Event types for better type safety
 */
export interface AnalyticsEvent {
  action: string;
  category: string;
  label: string;
  value?: number;
}

/**
 * Log page view to Google Analytics
 */
export const pageview = (url: string): void => {
  if (typeof window === 'undefined' || !window.gtag) {
    return;
  }
  
  try {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: url,
    });
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('[Analytics] Error tracking pageview:', error);
    }
  }
};

/**
 * Log specific events to Google Analytics
 */
export const event = ({ action, category, label, value }: AnalyticsEvent): void => {
  if (typeof window === 'undefined' || !window.gtag) {
    return;
  }
  
  try {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('[Analytics] Error tracking event:', error);
    }
  }
}; 